import { z } from "zod";

/**
 * Identifier type — the messaging channel an identifier belongs to.
 *
 * Single source of truth for the channel union. Used by:
 * - `server/src/domain/user/entities/user-identifier.entity.ts` (domain enum)
 * - `server/src/shared/schemas/user/get-or-create-user.schema.ts` (request validation)
 * - `shared-types/src/contracts/phone.contract.ts` (oRPC phone search response)
 */
export const IDENTIFIER_TYPE = [
	"whatsapp",
	"messenger",
	"telegram",
	"sms",
	"email",
] as const;

export const IdentifierTypeSchema = z.enum(IDENTIFIER_TYPE);

export type IdentifierType = z.infer<typeof IdentifierTypeSchema>;

export function isIdentifierType(value: unknown): value is IdentifierType {
	return IdentifierTypeSchema.safeParse(value).success;
}
